import { useEffect, useState } from 'react';
import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Skeleton from '@material-ui/lab/Skeleton';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  card: {
    padding: theme.spacing(2),
    borderRadius: 12,
    textAlign: 'center',
    minHeight: 90,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  number: {
    fontSize: '2.5rem',
    fontWeight: 700,
    lineHeight: 1.1,
    color: theme.palette.text.primary,
  },
  label: {
    fontSize: '0.75rem',
    fontWeight: 500,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5),
  },
}));

export const StatCardsRow = () => {
  const classes = useStyles();
  const catalogApi = useApi(catalogApiRef);
  const [stats, setStats] = useState<{ services: number; templates: number; apis: number; groups: number } | null>(null);

  useEffect(() => {
    Promise.all([
      catalogApi.getEntities({ filter: { kind: 'Component' }, fields: ['metadata.name'] }),
      catalogApi.getEntities({ filter: { kind: 'Template' }, fields: ['metadata.name'] }),
      catalogApi.getEntities({ filter: { kind: 'API' }, fields: ['metadata.name'] }),
      catalogApi.getEntities({ filter: { kind: 'Group' }, fields: ['metadata.name'] }),
    ]).then(([components, templates, apis, groups]) => {
      setStats({
        services: components.items.length,
        templates: templates.items.length,
        apis: apis.items.length,
        groups: groups.items.length,
      });
    }).catch(() => {
      setStats({ services: 0, templates: 0, apis: 0, groups: 0 });
    });
  }, [catalogApi]);

  const items = [
    { value: stats?.services, label: 'Services' },
    { value: stats?.templates, label: 'Templates' },
    { value: stats?.apis, label: 'APIs' },
    { value: stats?.groups, label: 'Teams' },
  ];

  return (
    <Grid container spacing={3}>
      {items.map(item => (
        <Grid item xs={6} md={3} key={item.label}>
          <Card className={classes.card} elevation={1}>
            {stats === null ? (
              <Skeleton variant="rect" height={48} width={60} style={{ margin: '0 auto', borderRadius: 8 }} />
            ) : (
              <>
                <Typography className={classes.number}>{item.value}</Typography>
                <Typography className={classes.label}>{item.label}</Typography>
              </>
            )}
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};
